import { render, staticRenderFns } from "./Oled.vue?vue&type=template&id=70e3511f&scoped=true"
import script from "./Oled.vue?vue&type=script&lang=js"
export * from "./Oled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e3511f",
  null
  
)

export default component.exports